<template>
    <div ref="homePage" class="all">
      <img src="static/images/tp_bg_ass@3x.png" alt="" class="img">
    </div>
</template>

<script>
    export default {
        name: "CastHelper",
      data() {
          return {
            clientHeight: '',
          }
      },
      methods: {
        changeFixed(clientHeight) {
          this.$refs.alert.style.height = clientHeight + 'px';
        },
      },
      mounted() {
        // 获取浏览器可视区域高度
        this.clientHeight =   `${document.documentElement.clientHeight}`;          //document.body.clientWidth;
        //console.log(self.clientHeight);
        window.onresize = function temp() {
          this.clientHeight = `${document.documentElement.clientHeight}`;
        };
      },
      watch: {
        // 如果 `clientHeight` 发生改变，这个函数就会运行
        clientHeight: function () {
          this.changeFixed(this.clientHeight)
        }
      },
    }
</script>

<style scoped>
  .all{
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/CastHelper.vue